
import { Link } from 'react-router-dom';

const ServicesSection = () => {
  const services = [
    {
      icon: "ri-search-eye-line",
      title: "Recherche d'emploi",
      description: "Accédez à des centaines d'offres d'emploi adaptées à votre profil et à vos compétences dans la région de Rouen.",
      features: ["Offres exclusives", "Matching intelligent", "Suivi personnalisé"],
      image: "https://static.readdy.ai/image/57eff6c71fc3277e2ea43d7b4bbfa9ea/df371c618022b64148f772d02c6331be.jpeg"
    },
    {
      icon: "ri-user-settings-line",
      title: "Accompagnement personnalisé",
      description: "Bénéficiez d'un accompagnement sur mesure avec nos conseillers spécialisés dans l'intégration professionnelle.",
      features: ["Coaching CV", "Préparation entretiens", "Formation linguistique"],
      image: "https://static.readdy.ai/image/57eff6c71fc3277e2ea43d7b4bbfa9ea/f34c3a3349f4d3f84cd9610e7d6619dd.jpeg"
    },
    {
      icon: "ri-team-line",
      title: "Recrutement d'entreprises",
      description: "Trouvez les talents dont vous avez besoin grâce à notre réseau de candidats qualifiés et motivés.",
      features: ["Présélection candidats", "Évaluation compétences", "Garantie remplacement"],
      image: "https://static.readdy.ai/image/57eff6c71fc3277e2ea43d7b4bbfa9ea/f1edd92c44db9135b13932ba3e9c73de.jpeg"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Nos Services d'Excellence
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Nous proposons une gamme complète de services pour répondre aux besoins 
            des candidats et des entreprises de la région rouennaise
          </p>
        </div>

        <div className="space-y-20">
          {services.map((service, index) => (
            <div key={index} className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-12`}>
              {/* Image */}
              <div className="flex-1">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-80 object-cover object-top rounded-2xl shadow-lg"
                />
              </div>

              {/* Contenu */}
              <div className="flex-1">
                <div className="w-16 h-16 bg-emerald-100 rounded-2xl flex items-center justify-center mb-6">
                  <i className={`${service.icon} text-emerald-600 text-2xl`}></i>
                </div>
                
                <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
                  {service.title}
                </h3>
                
                <p className="text-lg text-gray-600 mb-6">
                  {service.description}
                </p>

                <ul className="space-y-3 mb-8">
                  {service.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-center space-x-3">
                      <div className="w-6 h-6 bg-emerald-100 rounded-full flex items-center justify-center">
                        <i className="ri-check-line text-emerald-600 text-sm"></i>
                      </div>
                      <span className="text-gray-700">{feature}</span>
                    </li>
                  ))}
                </ul>

                <Link
                  to="/services"
                  className="inline-flex items-center space-x-2 bg-emerald-600 text-white px-6 py-3 rounded-lg hover:bg-emerald-700 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <span>En savoir plus</span>
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
